import { ButtonBar, ModalButton } from "pages/setting/components/Modal.styled";

export const ButtonList = ({
  closeModal,
  openConfirm,
  confirmMessage,
  disabled,
}) => {
  return (
    <ButtonBar>
      <ModalButton
        style={{ backgroundColor: "white", fontWeight: "500" }}
        onClick={closeModal}
      >
        취소
      </ModalButton>
      <ModalButton
        disabled={disabled}
        style={{ color: "white", fontWeight: "500" }}
        onClick={openConfirm}
      >
        {confirmMessage}
      </ModalButton>
    </ButtonBar>
  );
};
